import {
  INSERT_VISIBLE,
  REMOVE_VISIBLE,
  INSERT_VISIBLE_ITEM,
  REMOVE_VISIBLE_ITEM,
  RESET_VISIBLE_LIST,
  RESET_VISIBLE_POSITIONS
} from '../actions/visibility'
import {_} from 'vue-underscore'

const getDefaultState = () => ({
  visibleIndex: [],
  visibleIndexMin: 0,
  visibleIndexMax: 0
})

const state = getDefaultState()

const getters = {
  getVisibleIndex: state => state.visibleIndex,
  getVisibleIndexMin: state => state.visibleIndexMin,
  getVisibleIndexMax: state => state.visibleIndexMax
}

const actions = {
  [INSERT_VISIBLE]: ({ commit }, item) => {
    commit(INSERT_VISIBLE_ITEM, item)
  },
  [REMOVE_VISIBLE]: ({ commit }, position) => {
    commit(REMOVE_VISIBLE_ITEM, position)
  },
  [RESET_VISIBLE_POSITIONS]: ({commit}) => {
    commit(RESET_VISIBLE_LIST)
  }
}

const mutations = {
  [INSERT_VISIBLE_ITEM]: (state, position) => {
    state.visibleIndex = [...state.visibleIndex, position].sort()
    if (state.visibleIndex.length > 0) {
      state.visibleIndexMin = _.first(state.visibleIndex)
      state.visibleIndexMax = _.last(state.visibleIndex)
    }
  },
  [REMOVE_VISIBLE_ITEM]: (state, position) => {
    const index = _.indexOf(state.visibleIndex, position)
    if (index > -1) {
      state.visibleIndex.splice(index, 1)
      if (state.visibleIndex.length > 0) {
        state.visibleIndexMin = _.first(state.visibleIndex)
        state.visibleIndexMax = _.last(state.visibleIndex)
      }
    }
  },
  [RESET_VISIBLE_LIST]: (state) => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/visibility.js